<template>
    <div id="msg-box">
      <div id="msg-text">
        {{msg}}
      </div>
    </div>
</template>

<script>
export default {
  name: 'SentMsg',
  props: {
    msg: String
  }
}
</script>

<style>
#msg-box{
  float:right;
  background: #FFFFFF;
  padding-left:2%;
  border-top-left-radius: 20px; 
  border-bottom-left-radius: 20px; 
  border-bottom-right-radius: 20px;
  margin:1%;
}
#msg-text{
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  text-align: right;
  padding: 15px;
  color: #000000;
}
</style>